import State from './State';

export const get = (): {} => JSON.parse(sessionStorage.getItem('state') || '{}');

export const set = (state: State): void => sessionStorage.setItem('state', JSON.stringify(state));



// WEBPACK FOOTER //
// ./src/application/core/sessionState.ts